import InputS1Default from "./Inputs/InputS1Default";
import InputS1 from "./Inputs/InputS1";
import InputCurrencyS1 from "./Inputs/InputCurrencyS1";
import InputMaskS1 from "./Inputs/InputMaskS1";
import TextareaS1 from "./Textarea/TextareaS1";
import TextareaD1 from "./Textarea/TextareaD1";
import SelectS1 from "./Select/SelectS1";
import SelectD1 from "./Select/SelectD1";
import AsyncSelectS1 from "./Select/AsyncSelectS1";
import AsyncSelectS2 from "./Select/AsyncSelectS2";
import AsyncSelectD1 from "./Select/AsyncSelectD1";
import AsyncNestedSelectD1 from "./Select/AsyncNestedSelectD1";
import AsyncNestedSelectS1 from "./Select/AsyncNestedSelectS1";
import CheckboxS1 from "./Checkbox/CheckboxS1";
import CheckboxD1 from "./Checkbox/CheckboxD1";
import RadioS1 from "./Radio/RadioS1";
import RadioS2 from "./Radio/RadioS2";
import UploadS1 from "./Upload/UploadS1";
import UploadS2 from "./Upload/UploadS2";
import NewDatePicker from "./NewDatePicker";
import NewDatePickerDefault from "./NewDatePicker/default";
import CreatableSelect from "./CreatableSelect";

import "./style.scss";

export default {
    InputS1Default,
    InputS1,
    InputCurrencyS1,
    InputMaskS1,
    TextareaS1,
    TextareaD1,
    SelectS1,
    SelectD1,
    AsyncSelectS1,
    AsyncSelectS2,
    AsyncSelectD1,
    CheckboxS1,
    CheckboxD1,
    RadioS1,
    RadioS2,
    UploadS1,
    UploadS2,
    NewDatePicker,
    NewDatePickerDefault,
    CreatableSelect,
    AsyncNestedSelectD1,
    AsyncNestedSelectS1
}
